import createSagaMiddleware from 'redux-saga';
import { routerMiddleware } from 'react-router-redux';
import {
  applyMiddleware,
  createStore,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import * as Sentry from '@sentry/react';
import sagas from './sagas';
import rootReducer from './rootReducers';
import { toError } from '../common/lib/toError';

export default function configureStore(initialState, history) {
  const sagaMiddleware = createSagaMiddleware({
    onError: (error) => {
      Sentry.captureException(toError(error), { extra: { sagaStack: error.sagaStack } });
    },
  });

  const middleware = applyMiddleware(sagaMiddleware, routerMiddleware(history));

  const composeEnhancers = composeWithDevTools({
    trace: true,
    traceLimit: 25,
  });

  const store = composeEnhancers(middleware)(createStore)(rootReducer, initialState);

  sagaMiddleware.run(sagas, history);

  if (import.meta.webpackHot) {
    import.meta.webpackHot.accept('./rootReducers', async () => {
      const { default: nextRootReducer } = await import('./rootReducers');
      store.replaceReducer(nextRootReducer);
    });
  }

  return store;
}